import {Mutex} from "async-mutex";
import {BaseQueryApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError} from '@reduxjs/toolkit/query/react';

const mutex = new Mutex()

const baseQuery = fetchBaseQuery({
  baseUrl: '',
  prepareHeaders: (headers, { getState }) => {
    headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    return headers
  },
})

const baseQueryWithAuth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: object,
) => {
  await mutex.waitForUnlock()

  let result = await baseQuery(args, api, extraOptions)
  console.log("in1")
  console.log(result)

  if (result.error && (result.error as FetchBaseQueryError).status === 401) {
    console.log("in")
    if (!mutex.isLocked()) {
      const release = await mutex.acquire()
      try {
        window.location.href = '/login'
      } finally {
        release()
      }
    } else {
      await mutex.waitForUnlock()
      result = await baseQuery(args, api, extraOptions)
    }
  }
  return result
}

export default baseQueryWithAuth